module.exports = {
      id: "paper-plane-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#paper-plane-usage",
      toString: function () {
        return this.url;
      }
    }